import usFlag from "../assets/images/flags/us.jpg";
import spain from "../assets/images/flags/spain.jpg";
// import italy from "../assets/images/flags/italy.jpg";

interface Language {
  label: string;
  flag: string;
}

interface Languages {
  [key: string]: Language;
}

const languages: Languages = {
  en: {
    label: "English",
    flag: usFlag,
  },
  sp: {
    label: "Spanish",
    flag: spain,
  },
  // it: {
  //   label: "Italian",
  //   flag: italy,
  // },
};

export default languages;
